<template>
  <div class="devices">
    <vue-headful title="Gerätemanagement - FF Pfaffenhofen"/>
    <Header :menu-at="0" headerTitle="Gerätemanagement"/>
    <div class="container">
      <h1>Gerätemanagement</h1>
      <p>Verwaltungs Software zur Erstellung, Drucken und Management für die Geräte QR-Codes zur Verwendung mit MP-Feuer.</p>
      
      <h2>Management</h2>
      <p>Liste mit allen angelegten und gespeicherten QR-Codes. </p>
      <p>Einträge können über die Buttons der jeweiligen Einträge modifiziert oder gelöscht werden.</p>
      
      <div class="list">
        <button class="btn-default" @click="createShow()">
          <font-awesome-icon icon="plus-circle"></font-awesome-icon>
          <span>Neuer QR-Code</span>
        </button>
        <div class="sort-wrapper">
        <div class="category-select">
          <button class="btn-select" :class="{'active': activeCategory[0]}" @click="changeCategory(0)">Alle</button>
          <button class="btn-select" :class="{'active': activeCategory[1]}" @click="changeCategory(1)">LF</button>
          <button class="btn-select" :class="{'active': activeCategory[2]}" @click="changeCategory(2)">HLF</button>
          <button class="btn-select" :class="{'active': activeCategory[3]}" @click="changeCategory(3)">MZF</button>
          <button class="btn-select" :class="{'active': activeCategory[4]}" @click="changeCategory(4)">ATW</button>
          <button class="btn-select" :class="{'active': activeCategory[5]}" @click="changeCategory(5)">Son</button>
        </div>
        <div class="sort">
          <span class="sort-text"> 
            Sortieren nach: </span> 
          <span class="active-sort" @click="toggleSortMenu()" v-click-outside="closeSortMenu">
            <span>{{activeSortName}}</span>
            <span>
              <font-awesome-icon icon="sort"></font-awesome-icon>
            </span>
          </span>
          <div class="sort-menu" v-if="showSortMenu">
            <div class="sort-choice" :class="{'active': activeSort[0]}" @click="changeSort(0, 'Nummer')">
              <font-awesome-icon icon="sort-numeric-down"></font-awesome-icon>
              <span>Nummer</span>
            </div>
            <div class="sort-choice" :class="{'active': activeSort[1]}" @click="changeSort(1, 'Zuerst')">
              <font-awesome-icon icon="sort-amount-down"></font-awesome-icon>
              <span>Letzte</span>
            </div>
            <div class="sort-choice" :class="{'active': activeSort[2]}" @click="changeSort(2, 'Letzte')">
              <font-awesome-icon icon="sort-amount-up"></font-awesome-icon>
              <span>Zuerst</span>
            </div>
            <div class="sort-choice" :class="{'active': activeSort[3]}" @click="changeSort(3, 'Titel')">
              <font-awesome-icon icon="sort-alpha-down"></font-awesome-icon>
              <span>Titel</span>
            </div>
          </div>
        </div>
        </div>
        <div class="entry" v-for="entry in data" :key="entry.id">
           <QRCodeCard 
            :category="entry.category" 
            :number="entry.number" 
            :description="entry.description"  
            :title="entry.title" 
            :url="entry.url"
            :id="entry.key">
          </QRCodeCard>
        </div>
        <div class="entry-last"></div>
       
      </div>

    </div>

    <modal name="create-modal" :pivotY=0.2 height="auto" width="960px" :adaptive="true" :clickToClose="false">
      <div class="create-modal modal">
        <h1>Neues QR-Code</h1>
        <p>
          Legen Sie neues Gerät mit passendem QR-Code über das folgende Formular an. <br>
          Verfügbare Kategorien: <b>LF, HLF, MZF, ATW (Atemschutzwerkstatt) und Son (Sonstige).</b> <br>
          Nummern sollten im Format <b>xxx</b> vergeben werden, z.B. <b>000</b> oder <b>041</b>.
        </p>
        <form @submit.prevent="createSubmit()">
          <div class="modal-grid">
            <div class="div qr-code-preview">
              <div class="qr-code">
              <vue-qrcode :value="createData.url" errorCorrectionLevel="H"/>
              <p class="qr-code-text">
                <b>
                  {{createData.category}} {{createData.number}}
                </b>
              </p>
              </div>
            </div>
            <div>
              <div class="input-grid">
                <div>
                  <label for="title">Gerät <span class="required">*</span></label>
                  <div class="input-row">
                    <span class="input-icon">
                      <font-awesome-icon icon="heading"/>
                    </span>
                    <input type="text" placeholder="C-Schlauch"  v-model="createData.title"/>
                  </div>
                </div>
                <div>
                  <label for="title">Kategorie <span class="required">*</span></label>
                  <div class="input-row">
                    <span class="input-icon">
                      <font-awesome-icon icon="tags"/>
                    </span>
                    <input type="text" placeholder="LF"  v-model="createData.category"/>
                  </div>
                </div>
                <div>
                  <label for="title">Nummer <span class="required">*</span></label>
                  <div class="input-row">
                    <span class="input-icon">
                      <font-awesome-icon icon="tags"/>
                    </span>
                    <input type="text" placeholder="000"  v-model="createData.number"/>
                  </div>
                </div>
              </div>
              <div>
                <label for="title">URL <span class="required">*</span></label>
                <div class="input-row">
                  <span class="input-icon">
                    <font-awesome-icon icon="link"/>
                  </span>
                  <input type="text" placeholder="http://example.com/"  v-model="createData.url"/>
                </div>
              </div>
              <div>
                <label for="title">Beschreibung</label>
                <div class="input-row">
                  <span class="input-icon">
                    <font-awesome-icon icon="file-alt"/>
                  </span>
                  <input type="text" placeholder="Gerätebeschreibung"  v-model="createData.description"/>
                </div>
              </div> 
            </div>
          </div>
          
          
          <div class="footer">
            <button class="btn-primary" type="submit">
              <font-awesome-icon icon="plus-circle" />
              Erstellen</button>
            <button class="btn-cancel" @click="createHide()" type="reset">Abbrechen</button>
          </div>
        </form>
      </div>
    </modal>

    <Footer />
    <Scroll2Top />
  </div>

</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import QRCodeCard from '@/components/QRCodeCard.vue'
import Scroll2Top from '@/components/Scroll2Top.vue'
import ClickOutside from 'vue-click-outside'
import VueQrcode from 'vue-qrcode'

export default {
  name: 'devices',
  components: {
    Header, Footer, Scroll2Top, QRCodeCard, VueQrcode,
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      showCreate: false,
      activeCategory: [true, false, false, false, false, false],
      activeCategoryName: 'all',
      activeSortName: 'Nummer',
      activeSort: [true, false, false, false],
      activeSortNumber: 0,
      showSortMenu: false,
      createData: {
        title: "",
        category: "",
        number: "",
        url: "https://mp-feuer-example.de/device?id=",
        description: ""
      },
      data: []
    }
  },
  methods: {
    toggleDetails(id) {
      this.data[id].showDetails = !this.data[id].showDetails 
    },
    changeCategory(id) {
      this.activeCategory = [false, false, false, false, false, false]
      this.activeCategory[id] = true

      if(id == 0) 
        this.activeCategoryName = "all"
      else if(id == 1)
        this.activeCategoryName = "lf"
      else if(id == 2)
        this.activeCategoryName = "hlf"
      else if(id == 3)
        this.activeCategoryName = "mzf"
      else if(id == 4)
        this.activeCategoryName = "atw"
      else
        this.activeCategoryName = "son"

      this.updateView()
    },
    changeSort(id, name) {
      this.activeSort = [false, false, false, false]
      this.activeSort[id] = true
      this.activeSortName = name
      this.showSortMenu = false
      this.activeSortNumber = id
      this.updateView()
    },
    updateView() {
      this.data = []
      this.axios.get('http://localhost:8000/api/v1/qr?sortby=' + this.activeSortNumber
        + '&category=' + this.activeCategoryName)
        .then((response) => { 
          this.data.push(...response.data.data)
        })
    },
    toggleSortMenu() {
      this.showSortMenu = !this.showSortMenu
    },
    closeSortMenu() {
      this.showSortMenu = false
    },
    createShow() {
      this.$modal.show('create-modal')
    },
    createHide() {
      this.$modal.hide('create-modal')
      this.createData.title = ""
      this.createData.category = ""
      this.createData.body = ""
    },
    createSubmit() {
      this.axios.post('http://localhost:8000/api/v1/qr/create', {
          title: this.createData.title,
          description: this.createData.description,
          category: this.createData.category,
          url: this.createData.url,
          number: this.createData.number
        }, {withCredentials: true})
      .then((response) => {
        this.data.unshift(response.data.data)
        this.$modal.hide('create-modal')
      })
    }
  },
  mounted() {
    if(!this.$session.get("userID")) {
      this.$router.push('/')
      return
    }
    this.userID = this.$session.get("userID")

    this.axios.get('http://localhost:8000/api/v1/qr?sortby=0')
      .then((response) => { this.data = response.data.data })

  }
}
</script>

<style scoped lang="scss">
@import "../styles/theme.scss";

.container {
  margin: 100px auto;

  p {
    line-height: 28px;
  }

  h2 {
    span {
      color: $primary;
    }
  }
}

.btn-default  {

  font-size: 20px;
  color: $dark;
  width: 100%;
  background: $light-0;
  border: 2px dashed #b3b3b3;
  padding: 20px 20px;
  margin-bottom: 10px;

  svg {
    margin-right: 15px;
    color: $primary;
  }

  &:hover {
    border-color: $primary; 
  }
}

.category-select {

  display: inline-block;
  box-shadow: $shadow-light;
  z-index: 5;
  justify-self: start;
  align-self: start;

  .btn-select {
    padding: 5px 20px;
    margin: 0;
    border: none;
    background: $light-0;
    cursor: pointer;
    color: black;
    font-size: 16px;
    transition: 0.5s; 

    &:hover {
      background: #f2f2f2;
      transition: 0.5s; 
    }
  }

  .active {
    background: $primary;
    color: white;
    cursor: default;
    font-weight: bold;

    &:hover {
    background: $primary;
    }
  }
}

.sort {
  display: flex;
  justify-content: flex-end;
  font-size: 16px;
  position: relative;
  margin-bottom: 8px;

  .sort-text {
    margin-right: 16px;
    margin-top: 6px;
  }

  .active-sort {
    box-shadow: $shadow-light;
    border: none;
    background: $light-0;
    cursor: pointer;
    padding: 5px 20px;
    width: 120px;
    text-align: center;
    display: grid;
    grid-template-columns: 6fr 1fr;
    transition: 0.5s; 
    
    &:hover {
     background: #f2f2f2;
     transition: 0.5s; 
    }

    span {
      text-align: center;
    }
  }

  .sort-menu {
    position: absolute;
    top: 35px;

    cursor: pointer;
    box-shadow: $shadow-light;
    border: 1px solid #b3b3b3;
    background: $light-0;
    z-index: 2;

    .sort-choice {
      padding: 5px 20px 5px 40px;
      width: 98px;

      &:hover {
        background: #f2f2f2;
        transition: 0.5s; 
      }

      svg {
        margin-right: 5px;
      }
    }

    .active {
      background: $primary;
      color: white;

      &:hover {
        background: $primary;
      }
    }
  }
}

.list {
  
  .entry-last {
    border-top: 1px solid rgba(#b3b3b3, 0.6);
  }
}


.sort-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.modal {
  padding: 10px 30px;

  h1 {
    color: $primary;
  }

  p {
    color: lighten($dark, 40);
    font-size: 14px;
  }

  .modal-grid {
    display: grid;
    grid-template-columns: 200px auto;
    margin-top: 30px;
  }

  .input-grid {
    display: grid;
    grid-template-columns: 60% 20% 20%;
  }

  .footer {
    margin: 60px 0px 20px 0;
    display: flex;
    flex-direction: row-reverse;

    button  {
      font-size: 18px;
      font-weight: bold;
      margin-left: 12px;
    }

    .btn-cancel {
      color: lighten($dark, 40);
      background: none;
      border: none;
      cursor: pointer;

      &:hover {
        color: $dark;
      }
    }

    .btn-primary {
      color: desaturate($primary, 40);

      &:hover {
        color: $primary;
      }
    }
  }

  label {
    color: $dark;
    font-weight: bolder;

    .required {
      color: $primary;
    }
  }

  .input-row {
    margin: 4px 0px 12px 0px;
    display: grid;
    grid-template-columns: 40px auto;
  }

  .input-icon {
    background: lighten($gray, 48);
    color: lighten($dark, 12);
    
    border: 1px solid #e4e4e4;
    border-right: none;
    padding: 8px 10px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  input {
    border: 0px;
    padding: 0px 12px;
    border: 1px solid #e4e4e4;
    font-size: 16px;
    width: calc(100% - 40px);

    &:focus, &:active {
      box-shadow: 0px 0px 4px $primary;
    }
  }

  .input-error {
    color: $primary;
    margin-top: -6px;
  }

  .qr-code-preview {
    align-self: center;
    justify-self: start;
  }

  .qr-code {
    img {
      width: 180px;
    }

    p {
      font-size: 16px;
      text-align: center;
      height: 20px;
      margin-top: -10px;
      color: $dark;
    }
  }
}


</style>